/**
 * 将创意素材和标题转换为接口载荷
 * @param {Object} creative_message 创意内容表单数据
 * @returns {Object}
 */
export function transformCreativeContent({ material = {}, titles = [] } = {}) {
  const { images = [], videos = [] } = material;
  return {
    ...(images.length && {
      images: images.map(({ id, name, url }) => ({
        id,
        name,
        urls: url.map(({ url: item_url }) => item_url),
      })),
    }),
    ...(videos.length && {
      videos: videos.map(({ id, name, width, height, url }) => ({
        id,
        name,
        width,
        height,
        url: url[0].url,
        cover: url[0].thumb_url,
      })),
    }),
    ...(titles.length && { titles: titles.map(({ name }) => name) }),
  };
}

/**
 * 判断创意内容中是否至少包含一个素材或标题
 * @param {Object} creative_message 创意内容表单数据
 * @returns {boolean}
 */
export function hasCreativeContent({ material = {}, titles = [] } = {}) {
  return Boolean(material.images?.length || material.videos?.length || titles.length);
}
